import type { UseFormReturn } from "react-hook-form";
import { z } from "zod";
import { formFields, SchemaForm, SubmitButton, YStack } from "@medbillai/ui";
import { BotControl } from "./BotControl";
export const SignInSchema = z.object({
  email: formFields.text.email().min(1, "Email is required").describe("Email")
});
export const SignInForm = ({
  form,
  onSubmit,
  forceEnable
}: {
  forceEnable: boolean;
  form: UseFormReturn<{
    email: string;
  }>;
  onSubmit: (data: z.infer<typeof SignInSchema>) => void;
}) => {
  return <SchemaForm form={form} schema={SignInSchema} onSubmit={onSubmit} defaultValues={{
    email: ""
  }} formProps={{
    flex: 0,
    justifyContent: "center"
  }} props={{
    email: {
      placeholder: "example@email.com",
      autoCorrect: false,
      spellCheck: false
    }
  }} renderAfter={({
    submit
  }) => {
    return <YStack gap="$3" $platform-web={{
      mt: "$1"
    }}>
            <BotControl />
            <SubmitButton onPress={submit} forceEnable={forceEnable} $platform-web={{
        mt: "$3"
      }}>
              Continue
            </SubmitButton>
          </YStack>;
  }} data-sentry-element="SchemaForm" data-sentry-component="SignInForm" data-sentry-source-file="SignInForm.tsx">
      {fields => <YStack gap="$3">{Object.values(fields)}</YStack>}
    </SchemaForm>;
};